<template>
  <div :class="$style.errors">
    <div class="pt-4 pb-4 d-flex align-items-end mt-auto">
      <lottie-animation
        :path="lottie.src"
        :loop="true"
        :autoPlay="true"
        :width="lottie.width"
        :height="lottie.height"
      />
    </div>
    <div
      class="pl-5 pr-5 pt-5 pb-5 mb-auto text-dark font-size-30"
      :class="$style.container"
    >
      <div class="font-weight-bold mb-3">Page not found</div>
      <div>This page is deprecated, deleted, or does not exist at all</div>
      <div class="font-weight-bold font-size-70 mb-1">404 —</div>
      <div @click="handleGoToHome" class="btn btn-outline-primary width-100">
        Go Back
      </div>
    </div>
  </div>
</template>
<script>
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue"; // import lottie-vuejs
export default {
  name: "NotFound",
  data() {
    return {
      lottie: {
        src: "assets/lotties/404-grasshopper.json",
        width: 300,
        height: 300
      }
    };
  },
  components: {
    LottieAnimation
  },
  methods: {
    handleGoToHome() {
      this.$router.push("/");
    }
  }
};
</script>
<style lang="scss" module>
@import "../style.module.scss";
</style>
